import React from 'react';
import { motion } from 'framer-motion';
import { MapPin } from 'lucide-react';
export function NationwideSection() {
  return <section id="cobertura" className="py-24 bg-espresso relative overflow-hidden" data-id="element-136">
      {/* Subtle background pattern/texture */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'radial-gradient(#D4AF37 1px, transparent 1px)',
      backgroundSize: '40px 40px'
    }} data-id="element-137"></div>

      <div className="max-w-5xl mx-auto px-6 md:px-12 relative z-10 text-center" data-id="element-138">
        <motion.div initial={{
        opacity: 0,
        scale: 0.5
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold/10 mb-8" data-id="element-139">
          <MapPin className="w-8 h-8 text-gold" data-id="element-140" />
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-3xl md:text-5xl font-bold text-bone mb-8" data-id="element-141">
          Presencia <span className="text-gold italic" data-id="element-142">Sin Fronteras</span>
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-xl md:text-2xl text-bone/80 font-light leading-relaxed max-w-4xl mx-auto" data-id="element-143">
          Nuestra planta de producción despacha y ensambla proyectos de gran
          escala en{' '}
          <span className="text-gold font-medium" data-id="element-144">
            cualquier ciudad de Colombia
          </span>
          , garantizando puntualidad y acabados arquitectónicos superiores.
        </motion.p>
      </div>
    </section>;
}